module.exports = __webpack_public_path__ + "static/img/pic_coop04@2x.572bf91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/pic_coop04@2x.png
// module id = ILWP
// module chunks = 0